import React from 'react';
import styles from './styles.module.scss';
import texts from '../texts';
import {ReactComponent as IconExpend} from '../resources/icon_expand.svg';
import {Tooltip} from '../../../components/Common/Tooltip';

interface Props {
    onClick: () => void;
}
const PartModalExpand = ({onClick}: Props) => {
    return (
        <div className={styles.expendIconWrapper}>
            <Tooltip tooltip={texts.expand} zIndex={100120}>
                <IconExpend className={styles.expendIcon} onClick={onClick} />
            </Tooltip>
        </div>
    );
};

export default PartModalExpand;
